module.exports = __webpack_public_path__ + "static/unnamed-2--fd96bd12caef2c46b932bf9f57b8a4c2.png";